export { default } from './UiModal';
export { modalStyles } from './UiModal.styles';
export type { UiModalProps, UiModalSizeType } from './UiModal.types';
